<template>
  <div class="auth-container account-inactive-container">
    <img class="logo mb-4" alt="Feeds.automated logo" src="/app/images/logo.svg" />
    <h5 class="my-4">{{ $t('auth.account_inactive_welcome') }}</h5>
    <div class="d-flex flex-column w-75">
      <p class="paragraph-content paragraph-big text-center">{{ $t('auth.account_inactive_description_1') }}</p>
      <p class="paragraph-content paragraph-big text-center">{{ $t('auth.account_inactive_description_2') }}</p>
      <p class="paragraph-content paragraph-big text-center">{{ $t('auth.account_inactive_description_3') }}</p>
      <p class="paragraph-content paragraph-big text-center">
        <span>{{ $t('auth.account_inactive_description_4') }}</span><a href="mailto:feeds@bluerank.com" target="_blank"><strong>feeds@bluerank.com</strong></a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountInactive'
}
</script>
